const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export function vendorLogoUrl(node, opts = {}) {
  if (!node) return null;
  const qs = opts.transparent ? '?transparent=1' : '';
  if (node.vendor_has_logo && node.vendor_id) {
    return `${BACKEND_URL}/api/logos/vendor/${node.vendor_id}${qs}`;
  }
  const site = node.vendor_website;
  if (site) {
    try {
      const domain = new URL(site.startsWith('http') ? site : `https://${site}`).hostname;
      if (domain.includes('example.com')) return null;
      return `${BACKEND_URL}/api/logos/favicon/${domain}${qs}`;
    } catch {
      return null;
    }
  }
  return null;
}
